const MINUTE_MS = 60000

export function millisecondsUntilNextMinute(now = Date.now()) {
  return MINUTE_MS - (now % MINUTE_MS)
}
